import styled, { css } from 'styled-components';

type ContainerProps = {
  borderOrShadow: boolean;
};

export const Container = styled.li<ContainerProps>`
  ${({ borderOrShadow }) => css`
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: ${borderOrShadow ? 'none' : '0px 8px 16px 0px #00000014'};
    border: ${borderOrShadow ? '1pt solid #d5d5d6' : '0px'};
    width: 100%;
    cursor: pointer;

    .btn-remove {
      border: 0;
      margin: 0;
      outline: 0;
      background: transparent;
      cursor: pointer;
    }
  `}
`;

export const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
`;

export const ProductName = styled.h5`
  color: #555658;
  font-size: 16px;
  font-weight: 500;
`;

export const Link = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    color: var(--blue-einstein);
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    text-decoration: none;
  }

  svg {
    width: 12px;
    fill: var(--blue-einstein);
  }
`;

export const Price = styled.p`
  color: #898b8e;
  font-size: 14px;
  font-weight: 500;
  margin-top: 4px;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
`;

export const BodyWrapper = styled.div``;

export const Info = styled.p`
  color: #898b8e;
  font-size: 14px;
  font-weight: 500;
`;

export const CountWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
